import React from "react";
import { Block, Link } from "thorium-ui";

export const Bio = () => {
   const handleClick = (e) => {
      e.preventDefault();
      const contact = document.querySelector("#contact");
      contact.scrollIntoView({ behavior: "smooth" });
   };
   return (
      <Block
         xs={12}
         sm={12}
         md={9}
         lg={6}
         xl={4}
         className="animate fade slideY"
      >
         <p className="info-heading">
            I'm Jeff, a Web Developer from Upstate New York.
         </p>
         <p className="info-body">
            I enjoy developing creative, intuitive applications for the web,
            especially those implementing dark-mode support!
         </p>

         <p className="text-center">Interested in working with me?</p>
         <Block all={12} justify="center">
            <Link asAnchor href="#contact" onClick={(e) => handleClick(e)}>
               Let's connect!
            </Link>
         </Block>
      </Block>
   );
};

export default Bio;
